import cx from 'classnames'
import { NewCollabItemFormWrapper } from './NewCollabItemFormWrapper'
import { useState } from 'react'
import Styles from './NewCollabItem.module.scss'

const NewCollabItem = () => {
  const [elevated, setElevated] = useState(false)

  return (
    <div className={cx(Styles.newCollabItem, { [Styles.elevated]: elevated })}>
      <NewCollabItemFormWrapper active={elevated} onActiveChange={(value) => setElevated(value)} />
    </div>
  )
}

export { NewCollabItem }
